var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    {
      staticClass: "l-toasts",
      attrs: { name: "toast", tag: "div" },
      on: {
        "before-enter": _vm.showStart,
        "after-enter": _vm.showEnd,
        "after-leave": _vm.hideEnd
      },
      nativeOn: {
        mouseenter: function($event) {
          return _vm.toastsEnter($event)
        },
        mouseleave: function($event) {
          return _vm.toastsLeave($event)
        }
      }
    },
    _vm._l(_vm.toasts, function(toast, index) {
      return _c(
        "div",
        { key: toast.id, staticClass: "toast", attrs: { id: index } },
        [
          _c(
            "div",
            {
              staticClass: "move",
              style: { transform: "translateY(" + index * 100 + "%)" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "message u-row",
                  on: {
                    click: function($event) {
                      return _vm.toastClick(toast)
                    }
                  }
                },
                [
                  _c(_vm.icon[toast.type].component, {
                    tag: "component",
                    class: _vm.icon[toast.type].class
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "u-flex" }, [
                    _vm._v(_vm._s(toast.message))
                  ])
                ],
                1
              )
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }